module.exports = __webpack_public_path__ + "img/bolivia.4183afef.svg";